export type AffordabilityResponse = {
  loanAmount: number;
  loanToValue: number;
};

export enum LoanType {
  StudentLoan = 'STUDENT_LOAN',
  CreditCard = 'CREDIT_CARD',
  OtherLoan = 'OTHER_LOAN',
  Guarantee = 'ASSET_LOAN',
}

export enum PropertyType {
  Apartment = 'APARTMENT',
  Villa = 'HOME',
  HolidayHouse = 'HOLIDAY_HOME',
}

export type Property = {
  propertyType: PropertyType;
  monthlyPayment: string;
  remainingDebt: string;
};

type Debt = {
  loanType: string;
  remainingDebt: string;
  monthlyPayment: string;
  creditLimit: string;
};

export type AdditionalLendingFormDataType = {
  propertyType: PropertyType;
  municipality: string;
  monthlyPayment: string;
  estimatedValue: string;
  remainingDebt: string;
  secondaryApplicantExist: string | null;
  primaryApplicantIncome: string;
  secondaryApplicantIncome: string;
  partnership: string;
  children: number;
  cars: number;
  properties: Property[];
  debts: Debt[];
  loanAmount: string;
};

export type AffordabilityFormDataType = {
  propertyType: PropertyType;
  municipality: string;
  monthlyPayment: string;
  downpayment: string;
  secondaryApplicantExist: string | null;
  primaryApplicantIncome: string;
  secondaryApplicantIncome: string;
  partnership: string;
  children: number;
  cars: number;
  properties: Property[];
  debts: Debt[];
  loanAmount: string;
};

export type AffordabilityRequest = {
  loanData: {
    propertyType: string;
    municipality: string;
    downpayment: number;
    monthlyExpense: number;
    monthlyPayment: number;
  };
  applicant: { monthlyIncome: number };
  coapplicant?: { monthlyIncome: number };
  numberOfChildren: number;
  numberOfCars: number;
  properties: { type: string; remainingDebt: number; monthlyPayment: number }[];
  loans: { type: string; remainingDebt: number; monthlyPayment: number }[];
  creditCards: { limit: number }[];
};

export type labelWeight = 'normal' | 'bold';
